import { InventoryNoPerspectiveContainer } from "./container";

export const InventoryNoPerspectivePage = () => {
  return <InventoryNoPerspectiveContainer />;
};
